import {DatasetsApi} from "api/DatasetsApi";
import CopyTextWithButton from "components/basic/copy-text-with-button/CopyTextWithButton";
import React, {useEffect, useState} from "react";
import {useGetRecentData} from "api/api-hooks/datasets-hooks";
import {AutoComplete, AutoCompleteChangeParams, AutoCompleteCompleteMethodParams} from "primereact/autocomplete";
import {timeAgo} from "utils/time-utils";

interface IDatasetDropdownProps {
    // Dataset identifier
    value?: string | null;
    onChange: (e: string | null) => void;
    style?: React.CSSProperties;
    disabled?: boolean;
}

interface DropdownItem {
    value: string | number,
    label: string,
}

export function DatasetDropdown(props: IDatasetDropdownProps) {
    const [selectedDataset, setSelectedDataset] = useState<DropdownItem | null>(null);
    const [filteredDatasets, setFilteredDatasets] = useState<DropdownItem[]>([]);

    const [error, setError] = useState(false);
    const recentDataQuery = useGetRecentData([props.value!], {});

    useEffect(() => {
        if (recentDataQuery.data !== undefined && recentDataQuery.data[0]?.data.length > 0) {
            const {key: time, value} = recentDataQuery.data[0].data[0];
            setSelectedDataset({value: props.value!!, label: `${recentDataQuery.data[0].title} | ${value.toFixed(2)} ${recentDataQuery.data[0].unit} | ${timeAgo(time)}`});
        }
    }, [recentDataQuery.data]);

    const searchDatasets = (e: AutoCompleteCompleteMethodParams) => {
        DatasetsApi.queryDatasets(e.query, 100).then((r) => {
            if (!r.error && r.data) {
                const selections = r.data.map((it) => ({value: it.identifier, label: it.toString()} as DropdownItem))
                setFilteredDatasets(selections)
            } else {
                setError(true)
            }
        });
    }

    const onChange = (e: AutoCompleteChangeParams) => {
        setSelectedDataset(e.value);

        if (typeof e.value === "string") return; // Ignore string auto complete dumb input

        props.onChange(e.value?.value || null);
    }

    return (
        <div style={{display: 'flex', alignItems: 'center'}}>
            <AutoComplete placeholder="Select Dataset"
                          value={selectedDataset}
                          suggestions={filteredDatasets}
                          onChange={onChange}
                          completeMethod={searchDatasets}
                          minLength={3}
                          field="label"
                          onClear={() => {
                              setSelectedDataset(null);
                              props.onChange(null);
                          }}
                          dropdownMode="blank"
                          style={{width: "100%", ...props.style}}
                          dropdown
                          disabled={props.disabled}
            />
            {selectedDataset && <CopyTextWithButton text="" copyableText={props.value ?? ""} />}
        </div>
    );
}